import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';

import CurrencyConverter from '../../CurrencyConverter';

import messages from '../../../locale/jsonMessages';

import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const ServiceFee = (props) => {

    const { serviceFee, currency, userType } = props;

    return (
        <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
            <div className={cx(cs.commonSmallText16, cs.textStart)}>
                <FormattedMessage {...messages.serviceFee} />
            </div>
            <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                <span>{userType === "owner" && "- "} <CurrencyConverter amount={serviceFee} from={currency} /></span>
            </div>
        </div>
    );
}

export default withStyles(cs, s)(ServiceFee);

